module.exports = __webpack_public_path__ + "img/20200702_172405.7980fb68.jpg";